<template>
  <!-- TODO rework -->
  <div
    class="radio-select-main-container position-relative"
    :class="customClass"
    :tabindex="tabindex"
    @blur="showOptions = false"
  >
    <div class="radio-select-button bg-transparent" @click="showOptions = !showOptions">
      <div v-if="!selectedElementValueValidation()">{{ defaultText }}</div>
      <div class="d-flex align-items-center" v-if="selectedElementValueValidation()">
        <b-img
          v-if="data.find((d) => d.value == elementSelected).image ? true : false"
          fluid
          width="29px"
          height="29px"
          class="rounded-25 radio-select-image mr-1 image-sizing"
          :src="data.find((d) => d.value == elementSelected).image"
        ></b-img>
        <b-img
          v-if="!data.find((d) => d.value == elementSelected).image ? true : false"
          fluid
          width="29px"
          height="29px"
          class="rounded-25 radio-select-image mr-1 "
          :src="require(`@/assets/child-profile-empty.png`)"
        ></b-img>

        <div class="selected-element-text m-0 p-0">
          {{ data.find((d) => d.value == elementSelected).text }}
        </div>
        <span v-if="!showOptions">▼</span>
        <span v-if="showOptions">▲</span>
      </div>
    </div>
    <div class="radio-select-options position-absolute user-select-none" v-if="showOptions">
      <div
        v-for="(element, index) in data"
        :key="'children-' + index"
        :class="'border ' + (element.value == elementSelected ? 'selected-option' : '')"
        class="d-flex align-items-center user-select-none p-2"
        @click="
          () => {
            elementSelected = element.value;
            emitValue(element.value);
          }
        "
      >
        <b-img
          v-if="element.image ? true : false"
          fluid
          width="29px"
          height="29px"
          class="rounded-25 radio-select-image mr-1 image-sizing"
          :src="element.image"
        ></b-img>
        <b-img
          v-if="!element.image ? true : false"
          fluid
          width="29px"
          height="29px"
          class="rounded-25 radio-select-image mr-1"
          :src="require(`@/assets/child-profile-empty.png`)"
        ></b-img>
        <span class="no-pointer-event ml-2">{{ element.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'radioSelect',
  props: {
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    defaultText: {
      type: String,
      required: false,
      default: '-- --',
    },
    customClass: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
    },
    selectedValue: {
      default: null,
    },
  },
  watch: {
    selectedValue(newVal) {
      this.elementSelected = newVal;
    },
  },
  data() {
    return {
      elementSelected: this.selectedValue,
      showOptions: false,
    };
  },

  methods: {
    selectedElementValueValidation() {
      return this.elementSelected != null && this.data.find((d) => d.value == this.elementSelected);
    },
    emitValue(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<style scoped lang="scss">
.radio-select-main-container {
  min-width: max-content;
  width: max-content;
  max-width: max-content;

  .image-sizing {
    min-width: 29px;
    width: 29px;
    max-width: 29px;
    min-height: 29px;
    height: 29px;
    max-height: 29px;
    object-fit: cover;
  }

  .selected-element-text {
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .radio-select-image {
    border-radius: 4px;
  }

  .radio-select-button {
    border: none;
    cursor: pointer;
  }

  .radio-select-options {
    background-color: #ffffff;
    z-index: 20;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 3px 3px 6px #00000029;
    border: 1px solid #ced4da;
    height: min-content;
    top: 100;
    right: 0;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 50vh;
    max-width: 250px;
    cursor: pointer;

    width: 200px;
    max-width: 300px;
  }

  .radio-select-options div:hover {
    background-color: #c3e6cb;
  }

  .selected-option {
    background-color: var(--color-main) !important;
  }

  .no-pointer-event {
    pointer-events: none;
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.3);
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
    background-color: rgba(0, 0, 0, 0.5);
  }
}
</style>
